import { Box, width } from "@mui/system";
import * as React from "react";
import KycComp from "../../common/components/CustomisedKyc";
import { callApi } from "../../common/api";
import "./style/GeneralDetailUpdate.css";
import ScheduleMeeting from "../Layout/ScheduleMeeting";
import { useEffect, useState } from "react";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import {
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  Select,
  MenuItem,
  Modal
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CustomizedSnackbars from "../alert/alert";
import CheckoutForm from "./checkoutForm";

export default function WatchlistPay({ handleClose, sid }) {
  const [pages, setPages] = React.useState(0);
  const [stripePromise, setStripePromise] = useState(null);
  const [clientSecret, setClientSecret] = useState("");
  const [amount, setAmount] = useState("");
  const [currency, setCurrency] = useState('')
  const [payment, setPayment] = useState(false)


  const getPaymentData = async () => {
    const response = await callApi("get", "investor/getPayment")
    setPayment(response?.data?.response?.data?.isPaymentDone)
    if(!response?.data?.response?.data?.isPaymentDone){
      getStripeData()
    }
  }

  useEffect(() => {
    getPaymentData();
  }, []);
  async function getDetails() {
    try {
      const response = await callApi('get', 'userRegister')
      const data = response.data.response.data
      return data;
    } catch (error) {
      console.log(error, "error")
    }
  }
  
  
  const getStripeData = async () => {
    let publishedKey = await callApi('get', 'payments/config')
    setStripePromise(loadStripe(publishedKey?.data?.publishableKey));
    const userDetails = await getDetails();
    console.log("User details fetched: ", userDetails);
    let clientSecret = await callApi('post', 'payments/createPayment', {user: userDetails})
    setClientSecret(clientSecret?.data?.data?.clientSecret);
    setAmount(clientSecret?.data?.data?.amount)
    setCurrency(clientSecret?.data?.data?.currency)
    
  }
  

  const checkKyc = async () => {
    // let allData = localStorage.getItem("AllData")
    const response = await callApi('get', 'userRegister')
    const data = response.data.response.data

    if (data.kycStatus === 0) {
      setPages(0)
    }
    else if (data.kycStatus === 4 || data.kycStatus === 1) {
      setPages(1)
    }
  }

  React.useEffect(() => {
    checkKyc()
  }, [])

  const [snackBarMsg, setSnackBarMsg] = React.useState({
    message: "",
    severity: "success",
    open: false,
  });

  const [inputData, setInputData] = React.useState({
    passportNumber: "",
    isPassportValid: true
  });
  const [fileData, setFileData] = React.useState({
    passFront: "",
    passBack: "",
  });
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const passportNumberPattern = /^[A-Z0-9]{8,15}$/;
    const isPassportValid = passportNumberPattern.test(value);
    setInputData({
      ...inputData,
      [name]: value.toUpperCase(),
      isPassportValid,
    });
  };

  async function handleFileData(e) {
    const name = e.target.name;
    setFileData((prevState) => ({
      ...prevState,
      [name]: e.target.files[0],
    }));
  }

  async function handleUpdate() {

    if (!inputData?.isPassportValid) {
      setSnackBarMsg({
        message: "Please enter valid passport number.",
        severity: "error",
        open: true,
      });
      return
    }
    if (inputData.passportNumber && fileData.passFront && fileData.passBack) {
      let formData = new FormData();
      formData.append("passportNumber", inputData.passportNumber);
      formData.append("passPortBack", fileData.passBack);
      formData.append("passPortFront", fileData.passFront);

      try {
        const response = await callApi(
          "post",
          "investor/kyc",
          formData,
          { "content-type": "application/x-www-form-urlencoded" },
          true,
          true
        );
        if (response.data.response.status) {
          setSnackBarMsg({
            message: "Kyc sent for verification Successfully",
            severity: "success",
            open: true,
          });
        } else {
          setSnackBarMsg({
            message: "Some error occur",
            severity: "error",
            open: true,
          });
        }
      } catch {
        setSnackBarMsg({
          message: "Some error occur",
          severity: "error",
          open: true,
        });
      }
      setPages(1);
    } else {
      setSnackBarMsg({
        message: "Please fill in all the fields.",
        severity: "error",
        open: true,
      });
    }
  }
  async function handlePay() {
    setPages(2);
  }
  
  const appearance = {
    rules: {
      ".Label": {
        "color": "white"
      }
    }
  };

  const handleDelete = (name, fileInputRef) => {
    setFileData((prevState) => (
      {
        ...prevState,
        [name]: null
      }))
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  }

  return (
    <>
      <Box
        className="modalWistlist"
        sx={{
          width: "50%",
          height: "auto",
          backgroundColor: "#212121",
          display: "flex",
          alignItems: "left",
          flexDirection: "column",
          // paddingTop:"16px",
          padding: "24px",
          borderRadius: "15px 15px 15px 15px",
          margin: "auto",
          marginTop: "50px"
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            paddingBottom: "32px",
          }}
        >
          <Button onClick={handleClose} style={{ cursor: "pointer" }}><CloseIcon
            sx={{ background: "black", color: "white", borderRadius: "8px" }}
          />
          </Button>
        </Box>

        <Box display="flex" alignItems="center" paddingBottom={"32px"} marginTop={"12px"}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            marginRight={2}
            position="relative"
          >
            <img
              src={pages === 0 ? "/Vector.png" : "/VectorGreen.png"}
              alt="favIcon"
              style={{ width: "20px", height: "20px" }}
            />
            <Typography style={{ color: "white" }}>KYC</Typography>
            <div
              style={{
                position: "absolute",
                background: "transparent", // Customize the background color of the number
                color: "black", // Customize the color of the number
                borderRadius: "50%", // Make it circular
                width: "20px",
                height: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "14px",
              }}
            >
              1
            </div>
          </Box>

          <hr
            flexItem
            style={{
              flex: 1,
              border: "none",
              borderTop: `2px dotted ${pages === 0 ? 'white' : '#A2FBB3'}`,
              // height: "25px",
            }}
          ></hr>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            marginX={2}
            position="relative"
          >
            <img
              src={!payment ? "/Vector.png" : "/VectorGreen.png"}
              alt="Image 2"
              style={{ width: "20px", height: "20px" }}
            />
            <Typography style={{ color: "white" }}>Payment</Typography>
            <div
              style={{
                position: "absolute",
                background: "transparent", // Customize the background color of the number
                color: "black", // Customize the color of the number
                borderRadius: "50%", // Make it circular
                width: "20px",
                height: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "14px",
              }}
            >
              2
            </div>
          </Box>
          <hr
            flexItem
            style={{
              flex: 1,
              border: "none",
              borderTop: `2px dotted ${!payment ? 'white' : '#A2FBB3'}`,
              // height: "25px",
            }}
          ></hr>

          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            marginLeft={2}
            position="relative"
          >
            <img
              src="/Vector.png"
              alt="Image 3"
              style={{ width: "20px", height: "20px" }}
            />
            <Typography style={{ color: "white" }}>Timeslot</Typography>
            <div
              style={{
                position: "absolute",
                background: "transparent", // Customize the background color of the number
                color: "black", // Customize the color of the number
                borderRadius: "50%", // Make it circular
                width: "20px",
                height: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "14px",
              }}
            >
              3
            </div>
          </Box>
        </Box>

        {pages === 0 ? (
          <Box>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Typography variant="h5" style={{ color: "white" }}>
                KYC
              </Typography>
            </Box>
            <Box>
              <Grid
                container
                spacing={2}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "24px",
                  padding: "24px",
                }}
              >
                <KycComp
                  handleInputChange={handleInputChange}
                  inputData={inputData}
                  handleFileData={handleFileData}
                  fileData={fileData}
                  handleDelete={handleDelete}
                  watchlist
                />
                <Box sx={{ display: "flex" }}>
                  <Grid item xs={12}>
                    <Button id="buttons" onClick={handleUpdate}>
                      Next
                    </Button>
                  </Grid>
                </Box>
              </Grid>
            </Box>
          </Box>
        ) : pages === 1 && !payment ? (
          <Box>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Typography variant="h5" style={{ color: "white" }}>
                Payment
              </Typography>
            </Box>
            <Grid
              container
              spacing={2}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "24px",
                padding: "24px",
              }}
            >
              {clientSecret && stripePromise && (
                <Elements stripe={stripePromise} options={{ clientSecret, appearance }}>
                  <CheckoutForm payment={payment} pages={pages} startupId={sid} setPage={setPages} amount={amount} currency={currency} />
                </Elements>
              )}
            </Grid>
          </Box>
        )
          :
          (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center", // Center horizontally
                height: "100%", // Center vertically
                width: "100%",
              }}
            >
              <ScheduleMeeting
                startupId={sid}
                handleClose={handleClose}
                meetingStatus={"CREATE"}
              />
            </Box>
          )}
      </Box>
      <CustomizedSnackbars
        msgData={snackBarMsg}
        setMsgData={setSnackBarMsg}
      />
    </>
  );
}
